<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        icon="el-icon-plus"
        @click="open('add')"
      >添加</el-button>
      <el-button
        type="danger"
        size="mini"
        icon="el-icon-delete"
        @click="bulkDelete"
      >删除</el-button>
      <el-button
        type="success"
        size="mini"
        icon="el-icon-refresh"
        @click="getList()"
      >刷新</el-button>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="showtabelData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      style="width: 1311px"
      height="calc(100vh - 240px )"
      size="mini"
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="activityNo" label="编号" width="100" />
      <el-table-column prop="name" label="名称" width="200" class="sort" />
      <el-table-column prop="rewardEnabled" label="是否奖励" width="100">
        <template slot-scope="scope">
          {{ isRewardEnabled(scope.row) ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column prop="award5_name" label="累积5次奖励" width="200">
        <template slot-scope="scope">
          {{ isRewardEnabled(scope.row) ? scope.row.award5_name : '—' }}
        </template>
      </el-table-column>
      <el-table-column prop="award10_name" label="累积10次奖励" width="200">
        <template slot-scope="scope">
          {{ isRewardEnabled(scope.row) ? scope.row.award10_name : '—' }}
        </template>
      </el-table-column>
      <el-table-column prop="award15_name" label="累积15次奖励" width="200">
        <template slot-scope="scope">
          {{ isRewardEnabled(scope.row) ? scope.row.award15_name : '—' }}
        </template>
      </el-table-column>

      <el-table-column prop="continuateCard" label="是否续卡" width="100">
        <template slot-scope="scope">
          <div
            :style="{ color: scope.row.continuateCard ? '#67C23A' : '#e74c3c' }"
          >
            <!-- 是否续卡（1启用 0禁用） -->
            {{ scope.row.continuateCard === 1 ? "启用" : "禁用" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="是否启用" width="100">
        <template slot-scope="scope">
          <div :style="{ color: scope.row.status ? '#67C23A' : '#e74c3c' }">
            {{ scope.row.status ? "启用" : "禁用" }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" width="220">
        <template slot-scope="scope">
          {{
            $parseTime(new Date(scope.row.createdAt), "{y}-{m}-{d} {h}:{i}:{s}")
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="open('edit', scope.row)"
          >修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加编辑弹窗 -->
    <el-dialog
      :title="isEdit ? '修改' : '添加'"
      :visible.sync="dialogVisible"
      width="1200px"
      :close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="formData" label-width="220px" size="mini">
        <el-form-item label="名称">
          <el-input
            v-model="formData.name"
            placeholder="请输入名称"
            style="width: 200px"
            size="mini"
          />
        </el-form-item>
        <el-form-item label="是否奖励">
          <el-radio v-model="formData.rewardEnabled" :label="1">是</el-radio>
          <el-radio v-model="formData.rewardEnabled" :label="0">否</el-radio>
        </el-form-item>
        <el-form-item v-if="formData.rewardEnabled === 1" label="累计5次奖励">
          <el-select
            v-model="formData.award5"
            placeholder="请选择累计5次奖励"
            :disabled="isEdit && originalRewardEnabled === 1"
          >
            <el-option
              v-for="item in optionsActivityList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="formData.rewardEnabled === 1" label="累计10次奖励">
          <el-select
            v-model="formData.award10"
            placeholder="请选择累计10次奖励"
            :disabled="isEdit && originalRewardEnabled === 1"
          >
            <el-option
              v-for="item in optionsActivityList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="formData.rewardEnabled === 1" label="累计15次奖励">
          <el-select
            v-model="formData.award15"
            placeholder="请选择累计15次奖励"
            :disabled="isEdit && originalRewardEnabled === 1"
          >
            <el-option
              v-for="item in optionsActivityList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="是否续卡">
          <el-radio v-model="formData.continuateCard" :label="0">禁用</el-radio>
          <el-radio v-model="formData.continuateCard" :label="1">启用</el-radio>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-radio v-model="formData.status" :label="0">禁用</el-radio>
          <el-radio v-model="formData.status" :label="1">启用</el-radio>
        </el-form-item>
        <el-form-item>
          <el-button
            style="margin-right: 10px"
            @click="dialogVisible = false"
          >取消</el-button>
          <el-popconfirm
            title="确定添加？"
            @onConfirm="isEdit ? edit() : add()"
          >
            <el-button
              slot="reference"
              type="primary"
              class="edit-button"
            >保存</el-button>
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
// import uploadPic from '@/components/Upload/UploadPic' // 引入单图片上传组件
// import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
// import newUploadImage from '@/components/Upload/newUploadImage' // 上传图片
import environment from '@/utils/environment'
// Default SortableJS
// import Sortable from 'sortablejs'
import {
  getPointConfigList,
  addPointConfig,
  updatePointConfig,
  removePointConfig
} from '@/api/activity/pointConfig.js'

import { getTicketManList } from '@/api/ticketMan.js'

import { parseTime } from '@/utils'
export default {
  name: 'Order',
  // components: { uploadPic, VueUeditorWrap },
  data() {
    return {
      loading: false,
      total: 0,
      showtabelData: [], // 表单数据
      multipleSelection: [], // 选中项
      dialogVisible: false, // 弹窗标识
      formData: {
        name: '',
        rewardEnabled: 1,
        award5: '',
        award10: '',
        award15: '',
        award5_name: '',
        award10_name: '',
        award15_name: '',
        continuateCard: 1,
        status: 1
      }, // 选中项
      effectiveTime: [],
      isEdit: false,
      originalRewardEnabled: 1,
      config: {
        UEDITOR_HOME_URL: '/ueditor/', // 需要令此处的URL等于对应 ueditor.config.js 中的配置。服务器
        autoHeightEnabled: false,
        initialFrameHeight: 500,
        initialFrameWidth: 700,
        maximumWords: 9999999,
        // 上传文件接口
        serverUrl: '/gw/admin/operate/uploadBanner',
        headers: { Authorization: localStorage.getItem('token') },
        imageActionName: 'uploadimage',
        imageAllowFiles: ['.png', '.jpg', '.jpeg', '.gif', '.bmp'],
        imageUrlPrefix: '' /* 图片访问路径前缀 */,
        imagePathFormat: '',
        imageMaxSize: 1024 * 1000 * 10 // 单位B 10MB
      },
      sortable: null,
      optionsActivityList: []
    }
  },
  mounted() {
    this.getList()

    getTicketManList().then((res) => {
      console.log('22', res)
      if (res && res.length > 0) {
        this.optionsActivityList = res.map((item) => {
          return {
            label: item.name,
            value: item.id
          }
        })
      }
    })
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
  methods: {
    isRewardEnabled(config) {
      return config.rewardEnabled !== 0 && config.rewardEnabled !== '0'
    },
    syncRewardFields() {
      for (const count of [5, 10, 15]) {
        const key = `award${count}`
        const nameKey = `${key}_name`
        this.formData[key] = this.formData[key] || null
        const ticket = this.optionsActivityList.find(item => String(item.value) === String(this.formData[key]))
        this.formData[nameKey] = this.formData[key] ? (ticket?.label || this.formData[nameKey] || '') : ''
      }
    },
    toArrayEvent(item) {
      return [item]
    },
    // 图片上传回调
    upLoadImage(url) {
      this.formData.imgUrl = url
    },
    // 获取表单信息
    getList() {
      this.loading = true
      getPointConfigList()
        .then((res) => {
          this.showtabelData = res
          this.total = res.total
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 关闭添加弹窗
    handleClose() {
      // console.log(11)
      this.active = {}
    },
    initData() {
      this.originalRewardEnabled = 1
      this.formData = {
        name: '',
        rewardEnabled: 1,
        award5: '',
        award10: '',
        award15: '',
        award5_name: '',
        award10_name: '',
        award15_name: '',
        continuateCard: 1,
        status: 1
      }
    },
    open(type, item) {
      console.log(type, item)
      this.initData()
      this.effectiveTime = []
      if (type == 'add') {
        this.isEdit = false
        // setTimeout(() => {
        //   this.$refs.uploadPic.init('')
        // }, 0)
        this.dialogVisible = true
      } else if (type == 'edit') {
        this.isEdit = true
        this.formData = { ...this.formData, ...item }
        this.formData.rewardEnabled = this.isRewardEnabled(item) ? 1 : 0
        this.originalRewardEnabled = this.formData.rewardEnabled
        this.effectiveTime = [
          this.formData.effectiveStartTime,
          this.formData.effectiveEndTime
        ]
        this.dialogVisible = true
      }
    },
    // 添加
    add() {
      const [startTime, endTime] = this.effectiveTime
      this.formData.effectiveStartTime = parseTime(
        startTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      this.formData.effectiveEndTime = parseTime(
        endTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      this.syncRewardFields()

      console.log(this.formData)

      addPointConfig(this.formData)
        .then((res) => {
          this.getList()
          this.dialogVisible = false
          this.$message.success('添加成功')
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 修改
    edit() {
      const [startTime, endTime] = this.effectiveTime
      this.formData.effectiveStartTime = parseTime(
        startTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      this.formData.effectiveEndTime = parseTime(
        endTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      this.syncRewardFields()
      updatePointConfig(this.formData)
        .then((res) => {
          this.getList()
          this.dialogVisible = false
          this.$message.success('修改成功')
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 批量删除
    bulkDelete() {
      console.log(this.multipleSelection, 'this.multipleSelection')
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          roundButton: true
        })
          .then(() => {
            const ids = this.multipleSelection.map((item) => {
              return item.id
            })
            removePointConfig({ ids })
              .then((res) => {
                this.$message.success('删除成功')
                this.getList()
              })
              .catch((err) => {
                this.$message.error(err)
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      } else {
        this.$message.warning('请勾选要删除的选项')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.head_search {
  display: flex;
  // justify-content: space-around;
  width: 100%;
  .item_warp {
    display: flex;
    .el-checkbox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 20px;
    }
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #525252;
    }
  }
}
.role_warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
.isSyn {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
